import axios from "axios";
import ApiService from "../apiService";

class UserService {
  static async getAllUsers() {
    const result = await ApiService.get("/user/users");
    return result.data;
  }
  static async getAllCollaborators() {
    const result = await ApiService.get("/user/collaborators");
    return result.data;
  }

  static async getUser(userId) {
    const result = await ApiService.get(`/user/${userId}`);
    return result.data;
  }

  static async getUserRole(userId) {
    const result = await ApiService.get(`/user/${userId}/role`);
    return result.data;
  }

  static async getUserImage(userId) {
    try {
      const result = await axios.get(`/user/image/${userId}`, {
        responseType: "blob",
      });
      return result.data.size === 17 ? null : URL.createObjectURL(result.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return null;
      }
      return Promise.reject(error);
    }
  }

  static async uploadImage(formData) {
    const result = await ApiService.post("/user/upload-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result.data;
  }

  static async removeImage(userId) {
    const result = await ApiService.put(`/user/remove-image/${userId}`);
    return result.data;
  }

  static async updateUser(userId, user) {
    const response = await ApiService.put(`/user/update-user/${userId}`, user);
    return response.data;
  }
}

export default UserService;
